import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const IdentityIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  // style="enable-background:new 0 0 512 512;"
  return (
    <svg
      style={style}
      className={className}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M263.705,152.63C234.967,148.039,211,170.021,211,197c0,127.385-125.134,157.073-143.053,170.799
			c3.052,11.283,7.081,22.137,12.014,32.516C104.403,379.877,241,343.767,241,196.9h30c0,163.411-156.484,212.678-176.288,229.535
			c6.632,9.741,14.149,18.821,22.388,27.197c25.175-22.817,183.9-76.13,183.9-253.277C301,176.639,284.96,156.131,263.705,152.63z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M361,235.013V202.42c0-57.1-42.056-105.425-95.742-110.024C201.052,87.078,150.376,138.238,151,198.128
			c0.873,81.178-87.001,97.723-90,99.673V317c0,6.823,0.368,13.559,1.055,20.202C79.214,324.161,181,302.883,181,197
			c0-45.84,41.082-81.616,87.568-73.96C304.164,128.885,331,162.122,331,200.354c0,192.056-171.606,256.599-190.04,273.739
			c9.003,6.612,18.565,12.448,28.645,17.459c25.746-19.492,105.705-50.173,156.634-148.083l14.839-28.55l12.319,29.722
			c13.828,33.333,33.719,63.514,58.209,89.383c6.903-9.153,13.028-18.891,18.256-29.194C386.263,359.675,361,299.255,361,235.013z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256,0C148.48,0,61,89.48,61,197v69.19c2.999-1.978,60.573-12.931,60-67.74c-0.824-79.069,66.757-142.808,146.821-135.938
			C336.889,68.431,391,129.881,391,202.42v32.593c0,51.801,18.739,100.761,51.418,139.136C447.973,356.064,451,336.882,451,317V197
			C451,89.48,363.52,0,256,0z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M338.163,382.728c-51.925,81.476-119.799,112.024-133.381,122.217C221.135,509.409,238.253,512,256,512
			c52.881,0,100.844-21.233,136.007-55.532C370.851,434.506,352.453,409.902,338.163,382.728z"
          />
        </g>
      </g>
    </svg>
  );
};
